import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(auth)/(center)/sign-in/_components/LoginForm.tsx");
